import React, { Component } from 'react';

class Palabras extends Component {

    constructor(props){
        super(props);
        this.state={
            
        };
    }

    componentDidMount(){

    }

    render(){
        return(
            <div className="palabras"></div>
            )
    }

    componentDidUpdate(){

    }

}

export default Palabras;